import { api } from "@/api";
import { queryClient } from "@/queryClient";

type LogInRequest = {
  email: string;
  password: string;
};

type LogInResponse = {
  accessToken: string;
};

const { setAccessToken } = useAuth();

export const logIn = async (request: LogInRequest) => {
  const { body } = await api.post<LogInResponse>("/auth/user-login/", {
    body: request,
    authenticated: false,
    // The response sets the httpOnly refresh cookie.
    credentials: "same-origin",
  });

  queryClient.invalidateQueries([SITE_QUERY_KEY]);
  setAccessToken(body.accessToken);
};
